import React, { useContext } from 'react';
import Carousel from '../../carousel';
import Controls from './controls';
import { ActivationInProgressContext } from '../view';
import { ButtonActionType, ChevronDirection } from './controls/types';
import {
	SeamlesslyUpdateStakeholders,
	UnifyDocumentation,
	YourProjectPagesInJira,
} from './content';

const CAROUSEL_ITEM_COUNT = 3;
export const ActivationInProgressCarousel = () => {
	const { onDismiss } = useContext(ActivationInProgressContext);
	return (
		<Carousel slideRange={[1, CAROUSEL_ITEM_COUNT]}>
			<Carousel.Slide>
				<Carousel.Item position={1}>
					<YourProjectPagesInJira />
				</Carousel.Item>
				<Carousel.Item position={2}>
					<SeamlesslyUpdateStakeholders />
				</Carousel.Item>
				<Carousel.Item position={3}>
					<UnifyDocumentation />
				</Carousel.Item>
			</Carousel.Slide>
			<Carousel.Control>
				{({ onPrevious, isStart }) =>
					!isStart && <Controls.Chevron direction={ChevronDirection.LEFT} onPrevious={onPrevious} />
				}
			</Carousel.Control>
			<Carousel.Control>
				{({ onNext, isEnd }) =>
					!isEnd && <Controls.Chevron direction={ChevronDirection.RIGHT} onNext={onNext} />
				}
			</Carousel.Control>
			<Carousel.Control>
				{({ onNext, onChangePosition, visiblePosition, isEnd }) => (
					<Controls.Container>
						<Controls.Button buttonActionType={ButtonActionType.DISMISS} onClick={onDismiss} />
						<Controls.NavigationBulletGroup
							count={CAROUSEL_ITEM_COUNT}
							activePosition={visiblePosition}
							onNavigationBulletClick={onChangePosition}
						/>
						{isEnd ? (
							<Controls.Button buttonActionType={ButtonActionType.DONE} onClick={onDismiss} />
						) : (
							<Controls.Button buttonActionType={ButtonActionType.NEXT} onClick={onNext} />
						)}
					</Controls.Container>
				)}
			</Carousel.Control>
		</Carousel>
	);
};

export default ActivationInProgressCarousel;
